import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { profileApi, type ProfileUpdateRequest, type PasswordChangeRequest } from '../api'
import { useAuth } from '../../../app/providers'

export const useProfileUpdate = () => {
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const mutate = async (profileData: ProfileUpdateRequest) => {
    setIsPending(true)
    setError(null)
    try {
      await profileApi.updateProfile(profileData)
    } catch (err) {
      setError(err as Error)
      throw err
    } finally {
      setIsPending(false)
    }
  }

  return {
    mutate,
    isPending,
    error,
  }
}

export const usePasswordChange = () => {
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const navigate = useNavigate()

  const mutate = async (passwordData: PasswordChangeRequest) => {
    setIsPending(true)
    setError(null)
    try {
      await profileApi.changePassword(passwordData)
      navigate({ to: '/' })
    } catch (err) {
      setError(err as Error)
      throw err
    } finally {
      setIsPending(false)
    }
  }

  return {
    mutate,
    isPending,
    error,
  }
}

export const useProfileLogout = () => {
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const navigate = useNavigate()
  const { logout } = useAuth()

  const mutate = async () => {
    setIsPending(true)
    setError(null)
    try {
      await logout()
      navigate({ to: '/sign-in' })
    } catch (err) {
      setError(err as Error)
      throw err
    } finally {
      setIsPending(false)
    }
  }

  return {
    mutate,
    isPending,
    error,
  }
}
